import { trackEvent } from 'analytics/trackFunctions'
import { PendingIcon } from 'assets/icons'
import Logo from 'components/logo'
import PrimaryButton from 'components/primaryButton'
import { UserContext } from 'contexts/user'
import React, { useContext, useEffect } from 'react'

const Pending = () => {
  const { logout } = useContext(UserContext)

  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_pendiente_auditoria' })
  }, [])

  return (
    <>
      <header className='shadow-sm w-full h-14 bg-white md:py-4 flex items-center justify-center'>
        <Logo imgClassName='mb-0 w-[10.625rem]' showAlways />
      </header>
      <div className='h-full md:flex pt-8 md:w-full max-w-3xl md:mx-auto md:items-center md:h-70v md:justify-center text-black px-5'>
        <PendingIcon className='h-auto w-full md:w-96' />
        <div className='text-center grow flex flex-col justify-between'>
          <div>
            <p className='font-bold mt-10 md:text-3xl'>¡Muchas gracias!</p>
            <p className='font-bold text-xs mt-5'>
              Vamos a validar tu información...
            </p>
            <p className='mt-3'>
              ¡Te notificaremos cuando tu billetera esté habilitada!
            </p>
          </div>
          <div className='w-full mt-8 mx-auto md:mt-8'>
            <PrimaryButton
              className='md:w-336'
              buttonText='Cerrar Sesión'
              primaryButtonFunction={() => {
                trackEvent({
                  eventName: 'bille_boton_logout_confirmar',
                  withUTMParams: false
                })
                logout()
              }}
            />
          </div>
        </div>
      </div>
    </>
  )
}
export default Pending
